export const getCookie = (cookieName: string) => {
  if (typeof window === "undefined") {
    return "";
  }
  return document.cookie
    .split("; ")
    .find(row => row.startsWith(`${cookieName}=`))
    ?.split("=")[1];
};

export const setCookie = (
  cookieName: string,
  options: {
    cookieValue: string;
    path?: string;
    secure?: boolean;
    sameSite?: string;
  }
) => {
  if (typeof window !== "undefined") {
    document.cookie = `${cookieName}=${options.cookieValue}; path=${options.path || "/"}; domain=${getDomain()}; ${options.secure ? "secure;" : ""} SameSite=${options.sameSite || "Strict"}`;
  }
};

const getDomain = () => {
  let domain = "";

  const domainIndex = location.hostname.split(".");
  if (domainIndex.length > 0) {
    domain = [domainIndex[domainIndex.length - 2], domainIndex[domainIndex.length - 1]].join(".");
  }
  return domain;
};
